<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('设置资金密码')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="item">
        <p class="title">{{ $t('请输入资金密码') }}</p>
       <template v-if="isMobile">
    <van-password-input
      :focused="oshowKeyboard"
      :gutter="10"
      :length="4"
      :value="opw"
      @focus="oshowKeyboard = true;tshowKeyboard = false;"
    />
    <van-number-keyboard
      v-model="opw"
      :show="oshowKeyboard"
      @blur="oshowKeyboard = false"
      @input="opw.length !== 3 ? oshowKeyboard = true  : tshowKeyboard=true;"
    />
  </template>
  <template v-else>
    <input
      class="pc-password-input"
      type="password"
      maxlength="4"
      v-model="opw"
      placeholder="请输入资金密码"
      @focus="oshowKeyboard = false"
    />
  </template>
      </div>
      <div class="item">
        <p class="title">{{ $t('请再次输入资金密码') }}</p>
        <template v-if="isMobile">
    <van-password-input
      :focused="tshowKeyboard"
      :gutter="10"
      :length="4"
      :value="tpw"
      @focus="tshowKeyboard = true;oshowKeyboard=false;"
    />
    <van-number-keyboard
      v-model="tpw"
      :show="tshowKeyboard"
      @blur="tshowKeyboard = false"
      @input="tpw.length !== 3 ? tshowKeyboard = true  : tshowKeyboard = false;oshowKeyboard=false"
    />
  </template>
  <template v-else>
    <input
      class="pc-password-input"
      type="password"
      maxlength="4"
      v-model="tpw"
      placeholder="请再次输入资金密码"
      @focus="tshowKeyboard = false"
    />
  </template>
      </div>
      <van-button class="sub-btn" type="default" @click="setPayPassword()">{{ $t('提交') }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      opw: '',
      tpw: '',
      oshowKeyboard: true,
      tshowKeyboard: false,
      userInfo: {},
      isMobile: window.innerWidth < 768
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    setPayPassword() {
      this.oshowKeyboard = false;
      this.tshowKeyboard = false;
      if (this.opw.length !== 4) {
        this.oshowKeyboard = true;
        this.$toast(this.$t("请填写完整"));
        return false;
      }
      if (this.tpw.length !== 4) {
        this.tshowKeyboard = true;
        this.$toast(this.$t("请填写完整"));
        return false;
      }
      if (this.opw !== this.tpw) {
        this.$toast(this.$t("两次密码不一致" + '!'));
        return false;
      } else {
        this.$http({
          method: 'post',
          data: {paypassword: this.opw},
          url: 'user_set_paypw'
        }).then(res => {
          if (res.code === 200) {
            setTimeout(() => {
              this.$toast(res.msg);
            }, 500);
            this.$router.push("Mine")
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.radio = res.data.sex;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container .wrapper {
  height: 100%;
  //overflow-y: auto;
  background-color: #fff;
  //-webkit-overflow-scrolling: touch;
}

.container .wrapper .item .title {
  margin: 40px 0;
  line-height: 20px;
  font-size: 30px;
  font-weight: 500;
  color: #000;
  text-align: center;
}

::v-deep .van-password-input {
  width: 80%;
  height: 150px;
  margin: 0 auto;

}

::v-deep .van-password-input__security li {
  font-size: 30px;
  line-height: 30;
  background-color: #ebedf0;
}

::v-deep .van-password-input__security {
  height: 130px;
}

::v-deep .van-password-input .van-password-input__security .van-password-input__item {
  height: 100%;
  border: 0;
  text-align: center;
  border-radius: 30px;
}

.van-password-input__security i {
  width: 25px;
  height: 25px;
}

::v-deep .van-key {
  height: 100px;
  font-size: 55px;
  line-height: 20px;
  border-radius: 20px;
}

::v-deep .van-number-keyboard {
  z-index: 100;
  width: 100%;
  padding-bottom: 30px;
  background-color: #f2f3f5;
}

::v-deep .van-key__collapse-icon {
  width: 50px;
  height: 50px;
}

::v-deep .van-key__delete-icon {
  width: 50px;
  height: 50px;
}

.container .wrapper .sub-btn {
  margin: 110px 0 0 10%;
  height: 100px;
  width: 80%;
  font-size: 35px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}



// PC端适配：重置vw为px值，并适配430px宽度 (比例: 430/750 = 0.5733)
@media (min-width: 768px) {
  .container .wrapper {
    height: calc(100vh - 57px);
  }
  .container .wrapper .item .title {
    margin: 22px 0;
    line-height: 11px;
    font-size: 14px;
  }
  .container .wrapper .sub-btn {
    margin: 60px 0 0 42px;
    font-size: 18px;
    border-radius: 24px;
    height: 53px;
  }
  .pc-password-input {
    height: 55px;
    margin: 0 auto 32px;
    font-size: 16px;
    text-align: center;
    border-radius: 24px;
    border: 1px solid #ebedf0;
    background-color: #ebedf0;
    display: block;
    width: 90%;
  }
  ::v-deep {
    .van-password-input {
      height: 82px;
      .van-password-input__security {
        height: 72px;
        i {
          width: 14px;
          height: 14px;
        }
        .van-password-input__item {
          font-size: 22px;
          border-radius: 12px;
        }
      }
    }
    .van-number-keyboard {
      width: 430px;
      max-width: 430px;
      left: calc(50% - 215px);
      padding-bottom: 16px;
      .van-key {
        height: 55px;
        font-size: 28px;
        line-height: 22px;
        border-radius: 12px;
         .van-key__collapse-icon, .van-key__delete-icon {
          width: 28px;
          height: 28px;
         }
      }
    }
  }
}
</style>
